import { emptyArray } from "constants/defaultValues";

export const InitialQuoteList = {
  totalCount: 0,
  totalPages: 0,
  values: emptyArray,
};

export const QuoteActionRequiredByList = [
  { id: 1, name: "QuotesList.Dealer", color: "#d4b847" },
  { id: 2, name: "QuotesList.DeutscheLeasing", color: "#77a9b5" },
  { id: 3, name: "QuotesList.NoActionRequired", color: "#999999" },
];

export const QuoteOrderByList = [
  { id: 1, name: "QuotesList.TransactionId", dbFieldName: "TransactionId" },
  { id: 2, name: "QuotesList.PartnerName", dbFieldName: "PartnerName" },
  { id: 3, name: "QuotesList.LastActivityDate", dbFieldName: "LastActivityDate" },
  { id: 4, name: "QuotesList.QuoteStatusName", dbFieldName: "QuoteStatusName" },
  { id: 5, name: "QuotesList.CreationDate", dbFieldName: "CreationDate" },
];

export const InitialQuoteFilter = {
  page: 1,
  pageSize: 20,
  keyword: null,
  requiredById: null,
  responsibleId: null,
  orderById: 1,
};

export const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
